The lines in the category return graph represent the hypothetical performance of
the portfolio fully investing in the same basket of stocks under the category
definition with the same historical weightings (scaled to 100%).
